import styled from 'styled-components'

import { helpers } from '../../../styles/theme'

export const SectionTitle = styled.div`
	font-size: 16px;
	margin: 24px 0 12px;
	color: ${helpers.color.text};
	font-family: ${helpers.font.family.header};

	&:first-child {
		margin-top: 0;
	}
`
